import React, { useEffect, useState } from 'react';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { auth } from '../firebase';
import './adminMain.css';

const AdminMain = () => {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user);
      setIsLoading(false);
      if (!user) {
        navigate('/admin/login', { state: { from: location.pathname } });
      }
    });

    return () => unsubscribe();
  }, [navigate, location]);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/admin/login');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  const handleModuleClick = (moduleId) => {
    navigate(`/admin/${moduleId}`);
  };

  const adminModules = [
    { id: 'forside', title: 'Forside', icon: '🏠' },
    { id: 'om', title: 'Om', icon: '👥' },
    { id: 'nyheder', title: 'Nyheder', icon: '📰' },
    { id: 'terapi', title: 'Terapi', icon: '🧠' },
    { id: 'supervision', title: 'Supervision', icon: '👁️' },
    { id: 'uddannelse', title: 'Uddannelse', icon: '🎓' },
    { id: 'praktisk-priser', title: 'Praktisk og priser', icon: '💰' },
    { id: 'shop', title: 'Shop', icon: '🛒' },
    { id: 'viden', title: 'Viden', icon: '📚' },
    { id: 'kontakt', title: 'Kontakt', icon: '📞' }
  ];

  if (isLoading) {
    return (
      <div className="admin-loading">
        <div className="loading-spinner"></div>
        <p>Indlæser...</p>
      </div>
    );
  }

  if (!user) {
    return null; // Will redirect via useEffect
  }

  return (
    <div className="admin-container">
      <header className="admin-header">
        <div className="admin-logo">
          <img 
            src="/media/logo/psykologiskperspektiv-logo.avif" 
            alt="Psykologisk Perspektiv" 
            onClick={() => navigate('/admin')}
            style={{ cursor: 'pointer' }}
          />
        </div>
        <div className="admin-header-right">
          <div className="admin-user">
            <span>Logget ind som: </span>
            <strong>{user.email}</strong>
          </div>
          <button onClick={handleLogout} className="logout-button">Log ud</button>
        </div>
      </header>
      
      <main className="admin-content">
        <h1>Administration</h1>
        <p className="admin-welcome">
          Velkommen til administrationsområdet. Vælg en kategori herunder for at redigere indhold.
        </p>
        
        <div className="admin-grid">
          {adminModules.map((module) => (
            <div 
              key={module.id} 
              className="admin-module" 
              onClick={() => handleModuleClick(module.id)}
            >
              <div className="module-icon">{module.icon}</div>
              <h2>{module.title}</h2>
              <div className="module-arrow">→</div>
            </div>
          ))}
        </div>
      </main>
      
      <footer className="admin-footer">
        <p>&copy; {new Date().getFullYear()} Psykologisk Perspektiv - Admin Panel</p>
      </footer>
    </div>
  );
};

export default AdminMain;
